export default __webpack_public_path__ + "static/media/empl_even.d67af23a.svg";